import "./style.scss";
import { FC } from "react";
import { AOPUkraineInquiryData } from "@/src/types/admissionOffice";
import backForDocInquiryPage1 from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-blank_for_inquiry-1.webp";
import backForDocInquiryPage2 from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-blank_for_inquiry-2.webp";
import type { InquiryBasicCountry } from "../inquiryBasicRegistry";

interface AOPPrevProps {
  country: InquiryBasicCountry;
  bodyForPrev: AOPUkraineInquiryData;
}

const UKRAINIAN_MONTHS_GENITIVE = [
  "січня",
  "лютого",
  "березня",
  "квітня",
  "травня",
  "червня",
  "липня",
  "серпня",
  "вересня",
  "жовтня",
  "листопада",
  "грудня",
];

interface UaDateParts {
  day: string;
  month: string;
  year: string;
}

/** Splits `dd.mm.yyyy` into day / Ukrainian month / year for blank placement. */
const parseDateUaParts = (value: string): UaDateParts => {
  if (!value) return { day: "", month: "", year: "" };
  const [day, month, year] = value.split(".");
  const monthIdx = Number(month) - 1;
  if (!day || !year || monthIdx < 0 || monthIdx > 11) {
    return { day: value, month: "", year: "" };
  }
  return {
    day,
    month: UKRAINIAN_MONTHS_GENITIVE[monthIdx],
    year: year.slice(-2),
  };
};

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev }) => {
  const dateSolution = parseDateUaParts(bodyForPrev.dateSolution);
  const dateEnd = parseDateUaParts(bodyForPrev.dateEnd);

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${country} inquiry page-1`}>
        <img className="admission-office-prev-background" src={backForDocInquiryPage1} alt="" />
        <div className="admission-office-prev-section document-number">
          <span>{bodyForPrev.documentNumber || ""}</span>
        </div>
        <div className="admission-office-prev-section full-name-first">
          <span>{bodyForPrev.fullName || ""}</span>
        </div>
        <div className="admission-office-prev-section full-name-second">
          <span>{bodyForPrev.fullNameSecondLine || ""}</span>
        </div>
        <div className="admission-office-prev-section date-certification">
          <span>{bodyForPrev.dateCertification || ""}</span>
        </div>
      </div>

      <div className={`admission-office-prev ${country} inquiry page-2`}>
        <img className="admission-office-prev-background" src={backForDocInquiryPage2} alt="" />
        <div className="admission-office-prev-section date-solution">
          <span className="day">{dateSolution.day}</span>
          <span className="month">{dateSolution.month}</span>
          <span className="year">{dateSolution.year}</span>
        </div>
        <div className="admission-office-prev-section number-solution">
          <span>{bodyForPrev.numberSolution || ""}</span>
        </div>
        <div className="admission-office-prev-section speciality">
          <span>{bodyForPrev.speciality || ""}</span>
        </div>
        <div className="admission-office-prev-section date-end">
          <span className="day">{dateEnd.day}</span>
          <span className="month">{dateEnd.month}</span>
          <span className="year">{dateEnd.year}</span>
        </div>
      </div>
    </div>
  );
};

export default AOPPrev;
